import { defaultHttpClient } from 'shared/src/api/httpClient';

export const removeLikeOutfit = (sno: number) => {
  return defaultHttpClient
    .request<void>({
      method: 'DELETE',
      url: `/api/v2/outfits/${sno}/likes/`,
    })
    .then(result => result.data);
};
